import { render, staticRenderFns } from "./GrantsConstraintsPlansSlidDetailsEdit.vue?vue&type=template&id=f77b7abc&"
import script from "./GrantsConstraintsPlansSlidDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./GrantsConstraintsPlansSlidDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports